import React from "react";

function getPageWindows(current, total) {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const delta = 2;
    const middle = [];
    for (let i = Math.max(2, current - delta); i <= Math.min(total - 1, current + delta); i++) {
        middle.push(i);
    }
    const pages = [1];
    if (middle[0] > 2) pages.push('...');
    pages.push(...middle);
    if (middle[middle.length - 1] < total - 1) pages.push('...');
    pages.push(total);
    return pages;
}

const Pagination = ({ page, totalPages, onPageChange }) => {
    if (totalPages <= 1) return null;
    return (
        <div className="d-flex justify-content-center align-items-center flex-wrap gap-1 mt-3">
            <button
                className="btn btn-outline-primary btn-sm"
                disabled={page === 1}
                onClick={() => onPageChange(Math.max(page - 1, 1))}
            >
                <i className="fa fa-angle-double-left" />
            </button>
            {getPageWindows(page, totalPages).map((p, i) =>
                p === '...' ? (
                    <span key={`dots-${i}`} className="px-2 align-self-center">…</span>
                ) : (
                    <button
                        key={p}
                        className={`btn btn-sm ${page === p ? 'btn-primary' : 'btn-outline-primary'}`}
                        onClick={() => onPageChange(p)}
                    >
                        {p}
                    </button>
                )
            )}
            <button
                className="btn btn-outline-primary btn-sm"
                disabled={page === totalPages}
                onClick={() => onPageChange(Math.min(page + 1, totalPages))}
            >
                <i className="fa fa-angle-double-right" />
            </button>
        </div>
    );
};

export default Pagination;
